import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";

import SiteLayout from "@/components/SiteLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import FaqPage from "@/pages/FaqPage";
import AgentsPage from "@/pages/AgentsPage";
import JournalPage from "@/pages/JournalPage";
import JournalPostPage from "@/pages/JournalPostPage";
import GetStartedPage from "@/pages/GetStartedPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyRequestPage from "@/pages/PrivacyRequestPage";

import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminAgents from "@/pages/admin/AdminAgents";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminContent from "@/pages/admin/AdminContent";
import AdminPrivacyRequests from "@/pages/admin/AdminPrivacyRequests";
import AdminAccount from "@/pages/admin/AdminAccount";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <ContentProvider>
                    <BrowserRouter>
                        <Toaster position="top-right" richColors />
                        <Routes>
                            <Route element={<SiteLayout />}>
                                <Route index element={<HomePage />} />
                                <Route path="about" element={<AboutPage />} />
                                <Route path="faq" element={<FaqPage />} />
                                <Route path="agents" element={<AgentsPage />} />
                                <Route path="journal" element={<JournalPage />} />
                                <Route path="journal/:slug" element={<JournalPostPage />} />
                                <Route path="get-started" element={<GetStartedPage />} />
                                <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                                <Route path="terms" element={<TermsPage />} />
                                <Route path="privacy/request" element={<PrivacyRequestPage />} />
                            </Route>

                            <Route path="/admin/login" element={<AdminLoginPage />} />
                            <Route path="/admin" element={<AdminLayout />}>
                                <Route index element={<AdminDashboard />} />
                                <Route path="leads" element={<AdminLeads />} />
                                <Route path="agents" element={<AdminAgents />} />
                                <Route path="blog" element={<AdminBlog />} />
                                <Route path="content" element={<AdminContent />} />
                                <Route path="privacy" element={<AdminPrivacyRequests />} />
                                <Route path="account" element={<AdminAccount />} />
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </ContentProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
